import { makeStyles, createStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
        },
        skeletonCamera: {
            minWidth: "25em",
            minHeight: "18em",
        },
        navHeader: {
            display: "flex",
            justifyContent: "space-around",
        },
        navText: {
            fontWeight: "bolder",
            width: "100%",
            textAlign: "center",
        },
        camList: {
            overflowX: "hidden",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            flexBasis: 0,
            flexGrow: 1,
            listStyle: "none",
            paddingRight: "5.2em",

            "& > li": {
                marginBottom: "1em",
            },
        },
        camListHeader: {
            marginBottom: 12,
            color: theme.palette.grey[700],
        },
        camListSection: {
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            justifyContent: "space-between",
        },
        camListSectionTopHeader: {
            fontSize: 24,
            fontWeight: "bold",
            marginBottom: "0.9rem",
        },
        camListSectionHeader: {
            fontSize: 24,
            fontWeight: "bold",
            marginBottom: 18,
        },
        loadingCamList: {
            overflow: "hidden",
        },
    }),
);
